// extracted by mini-css-extract-plugin
export default {"generic_error":"s3t6fpZ2pXgwrXNo8r3k","btn":"Z2fYmrCZMW53S28IS4Mc","generic_error__center":"cgFbXcLYk5zl8WIs8Jdz"};
    if(module.hot) {
      // 1719312944670
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  